import { render } from "./Delete.vue?vue&type=template&id=4b4f5910&scoped=true&bindings={\"confirm\":\"options\"}"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"

import "./Delete.vue?vue&type=style&index=0&id=4b4f5910&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b4f5910"

export default script